import { AuthorizeUserAccessRequest, UserProfile } from "../auth.types";

export class AuthorizeUserAccessAdaptor implements UserProfile {
  public id: number;
  public email?: string;
  public name?: string;
  public userType?: number;
  public dtRef?: string;
  public inactive?: boolean | null;
  public emailAccessResponsable?: string | null;

  constructor(data: AuthorizeUserAccessRequest) {
    this.id = data.ID_USUARIO;
    this.email = data.EMAIL;
    this.userType = data.ID_USUARIO_TP_ACESSO;
    this.dtRef = data.DT_REFERENCIA;
    this.inactive = data.IND_INATIVO;
    this.emailAccessResponsable = data.EMAIL_USUARIO;
  }
  get userProfile(): UserProfile {
    return {
      id: this.id,
      email: this.email,
      userType: this.userType,
      inactive: this.inactive,
      emailAccessResponsable: this.emailAccessResponsable,
    };
  }
}
